import {data}from "./data.js"

import Main from "../../components/Main/Main.js"


const Neptune = () => {
    return (
        <>
        <Main
        planetData={data}
        />
        </>
    )
}

export default Neptune